module.exports = __webpack_public_path__ + "static/media/Computer Network & Comm.81b3d2e7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CSE/Computer Network & Comm.pdf
// module id = 97
// module chunks = 0